// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4EBo6j8XiqE5yLw9BR4{height:100%}.aI4OVtkm2lOvEdKND9pW{display:flex;flex-direction:column;flex:1;height:calc(100% - 68px);max-width:1280px;margin:0 auto;padding-left:16px;padding-right:16px}.aI4OVtkm2lOvEdKND9pW p,.aI4OVtkm2lOvEdKND9pW li{font-size:14px;line-height:20px}.S5Xko9tar8fvdQ7P4u2s{width:100%;height:100%;display:flex;flex-direction:column}.JamUF0jmBrm16DHEqOWH{height:68px}.cQ_nmA2NRr_qSZSgm5mR h1{text-align:center;color:#8292b1;font-size:14px;line-height:22px;font-weight:600;margin:8px 0;letter-spacing:.25em;text-transform:uppercase}.cQ_nmA2NRr_qSZSgm5mR h2{text-align:center;color:#141941;font-size:16px;line-height:20px;font-weight:400;margin:8px 0}.cQ_nmA2NRr_qSZSgm5mR p{font-size:14px;line-height:20px;color:#8496b9;margin:8px 0}.cQ_nmA2NRr_qSZSgm5mR.fK2TyKz9HUPsi84E0c_L h1,.cQ_nmA2NRr_qSZSgm5mR.fK2TyKz9HUPsi84E0c_L h2,.cQ_nmA2NRr_qSZSgm5mR.fK2TyKz9HUPsi84E0c_L p{text-align:center}.EO_XJrnCREOm05nzpYmi{position:relative}.EO_XJrnCREOm05nzpYmi .f0jAMu2dtjjqZ2vVgbI7{align-self:flex-start}.EO_XJrnCREOm05nzpYmi.EQgkTXidKemuOmiq4Djh p{margin-top:0}.EO_XJrnCREOm05nzpYmi.EQgkTXidKemuOmiq4Djh .EcjfxIWurLakYoz3okUT{box-sizing:content-box;padding:15px 20px;overflow:hidden;display:flex;flex-direction:row;align-items:center;justify-content:space-between;gap:8px}.EO_XJrnCREOm05nzpYmi.EQgkTXidKemuOmiq4Djh .EcjfxIWurLakYoz3okUT p{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;padding-right:16px}.EO_XJrnCREOm05nzpYmi.EQgkTXidKemuOmiq4Djh .BfHb0IEi3_oeUbLsKItH{padding:15px 20px;background-color:#fff;position:absolute;left:0;top:0;width:100%;display:flex;flex-direction:row;justify-content:space-between;gap:8px;z-index:100;box-shadow:0 4px 6px 0 rgba(184,186,202,.25);border-radius:5px}.EO_XJrnCREOm05nzpYmi.EQgkTXidKemuOmiq4Djh .BfHb0IEi3_oeUbLsKItH hr{height:1px;border:none;background-color:#ecedf5;margin:16px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"slideView": `_4EBo6j8XiqE5yLw9BR4`,
	"slideWrapper": `aI4OVtkm2lOvEdKND9pW`,
	"layoutWrapper": `S5Xko9tar8fvdQ7P4u2s`,
	"nav": `JamUF0jmBrm16DHEqOWH`,
	"header": `cQ_nmA2NRr_qSZSgm5mR`,
	"taskHeader": `fK2TyKz9HUPsi84E0c_L`,
	"descriptionWrapper": `EO_XJrnCREOm05nzpYmi`,
	"control": `f0jAMu2dtjjqZ2vVgbI7`,
	"collapsible": `EQgkTXidKemuOmiq4Djh`,
	"collapsedDescription": `EcjfxIWurLakYoz3okUT`,
	"expandedDescription": `BfHb0IEi3_oeUbLsKItH`
};
export default ___CSS_LOADER_EXPORT___;
